import { QuestionCircleOutlined } from '@ant-design/icons'
import type { ReactNode } from 'react'
import styled from 'styled-components'
import Popover from '../../Popover'

type HelpPopoverProps = {
  title: string | undefined
  content: ReactNode | undefined
  className?: string
}

const HelpPopover = (props: HelpPopoverProps) => {
  const { title, content, className } = props

  return (
    <Popover title={title} content={<HelpBody>{content}</HelpBody>}>
      <QuestionCircleOutlined className={className} />
    </Popover>
  )
}

const HelpBody = styled.div`
  max-width: min(600px, calc(100vw - 48px));
  white-space: normal;
  overflow-wrap: break-word;
`

export default HelpPopover
